/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/home/caHome',
	'react'
], function (caHome, React) {

	const { GetStartedTabView } = caHome;
	class GetStartedTab {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.itemSpec = options.itemSpec;
		}

		render() {
			return (React.createElement(GetStartedTabView, {
				glassContext: this.glassContext,
				itemSpec: this.itemSpec
			}));
		}

	}
	return GetStartedTab;
});